module.exports = __webpack_public_path__ + "assets/c7aa985bd40912bc089f5df612943253.png";